/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EndpointParams } from 'src/app/models/http/endpoint-params';
import { environment } from 'src/environments/environment';

const defaultOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export abstract class HttpService {
    private readonly http = inject(HttpClient);

    noShowErrorNotification = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', showErrorMessage: 'false' })
    };

    defaultEndpoint = environment.apps.center;

    protected buildGetParams(httpParameters: HttpParams): { params: HttpParams } {
        return { params: httpParameters };
    }

    protected get(url: string, endpointParams: EndpointParams, params?: any): Observable<any> {
        return this.http.get(this.getEndpoint(url, endpointParams), params);
    }

    protected post(url: string, endpointParams: EndpointParams, params?: any, options?: any): Observable<any> {
        return this.http.post(this.getEndpoint(url, endpointParams), params, options ? options : defaultOptions);
    }

    protected put(url: string, endpointParams: EndpointParams, params?: any, options?: any): Observable<any> {
        return this.http.put(this.getEndpoint(url, endpointParams), params, options ? options : defaultOptions);
    }

    protected delete(url: string, endpointParams: EndpointParams, options?: any): Observable<any> {
        return this.http.delete(this.getEndpoint(url, endpointParams), options ? options : defaultOptions);
    }

    private getEndpoint(url: string, endpointParams: EndpointParams): string {
        let endpoint = `${environment.apps[endpointParams.app]}`;

        if (endpointParams.version) {
            endpoint += `/v${endpointParams.version}`;
        }
        endpoint += `/${url}`;

        return endpoint;
    }

    protected showSuccessMessage(message = 'save_successful', showError = true): { headers: HttpHeaders; body: any } {
        // TODO: Intentar implementar una mejor forma de generar headers configurando si mostrar o no mensajes de éxito y error.
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', showSuccessMessage: message, showErrorMessage: showError.toString() }),
            body: {}
        };
    }
}
